// 因为@/utils/env 和 @/utils/util 互相引用了，单独拆一下

export const getQueryParams = function (input = '') {
    const url = input || location.search || ''; // 获取url中"?"符后的字串
    // 处理客户端直播间拼接参数出现两个问号的情况，临时处理将author_id前面的?改为&
    const str = url.substr(1).replace(/\?author_id/, '&author_id');
    const theRequest = Object.create(null);
    const strs = str.split('&').filter(Boolean);
    for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
    return theRequest;
};
